module.exports = __webpack_public_path__ + "img/fullscn-alert.4ae9f045.svg";